import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import * as helper from '../util/helper';
import ErrorPage from '../ErrorPage/ErrorPage';
import {
  Page
  , Content
  , Prompts
} from '@beisen/chaos-ui';
import { formatIndexData, cmpContext, indexContext, existButton, hasNavViewData } from './function';
import IndexNav from './IndexNav';
import IndexWidget from './IndexWidget';
import IndexContent from './IndexContent';
import IndexFooter from './IndexFooter';
import transLoader from '@beisen/i18n-translation-loader';
require('./indexpage.scss');

const defaultTranslation = {
  pageError: '页面错误',
  saveError: '保存失败',
  cancel: '取消',
  confirm: '确定',
  checkAll: '全选',
  toTop: '顶部'
};
export default class IndexPage extends Component {
  constructor(props, context) {
    super(props, context);
    this.IndexData = {};
    this.sortData = [];
    this.getData(props);
    this.getSearchCondition = this.getSearchCondition.bind(this);
    this.reloadTable = this.reloadTable.bind(this);
    this.hideTopAndBottom = this.hideTopAndBottom.bind(this);
    this.displayTopAndBottom = this.displayTopAndBottom.bind(this);
    this.handleToTop = this.handleToTop.bind(this);
    this.displayToTop = this.displayToTop.bind(this);
    this.hideToTop = this.hideToTop.bind(this);
    this.closePop = this.closePop.bind(this);
    this.switchViewShowChange = this.switchViewShowChange.bind(this);
    this.viewActived = this.viewActived.bind(this);
    this.changeHolderHeight = this.changeHolderHeight.bind(this);
    this.setSortData = this.setSortData.bind(this);
    this.currentDetailPageViewName = this.currentDetailPageViewName.bind(this);
    this.getContentScrollTop = this.getContentScrollTop.bind(this);
    this.showFooter = this.showFooter.bind(this);
    this.getFooterHeight = this.getFooterHeight.bind(this);
    window.BSnav = { 'closePop': this.closePop };
    this.hideBar = false;
    this.currentViewIsCustomComponent = false;
    this.translation = Object.assign({}, defaultTranslation, transLoader({
      pageError: 'pageNotice.pageError',
      cancel: 'common.cancel',
      confirm: 'common.confirm',
      checkAll: 'table.checkAll',
      toTop: 'table.toTop',
      saveError: 'tip.saveError'
    }), props.translation);
  }

  componentDidMount() {
    //降域
    helper.reducedDomain();
    if (window.env.platform.bsAppIOS) {
      try {
        helper.getEnv().on({
          name: 'viewappear'
        }, () => {

          if (window.unReloadTable) {
            window.unReloadTable = false;
          } else {
            this.reloadTable({
              searchData: this.getSearchCondition(),
              sortData: this.sortData
            });
          }
        });
      } catch (e) {
        //错误了
      }

    }
  }

  componentWillReceiveProps(nextProps, nextState) {
    this.getData(nextProps);
    if (this.isActiveViewChanged(nextProps)) {
      this.activeViewChanged = true;
    }
    if (!nextProps.isClick) {
      this.navView = this.IndexData.NavView;
    }
  }

  // 根据激活标示决定是否刷新TableList
  componentDidUpdate() {
    if (this.activeViewChanged) {
      this.activeViewChanged = false;
    }
  }

  componentWillUnmount() {
    this.props.actions.clearIndexPageData();
  }

  getData(props) {
    const { cmp_id, sub_cmps, isFetching } = props;
    this.IndexData = formatIndexData({ isFetching, cmpId: cmp_id, subCmps: sub_cmps }) || {};
  }

  // 确实是否点击是相同的页签
  isActiveViewChanged(nextProps) {
    if (nextProps.sub_cmps && nextProps.sub_cmps.length > 0
      && this.props.sub_cmps && nextProps.sub_cmps.length > 0) {
      const newActiveView = nextProps.sub_cmps.find(item => {
        return item.cmp_type === 'IndexView';
      });
      const preActiveView = this.props.sub_cmps.find(item => {
        return item.cmp_type === 'IndexView';
      });
      if (newActiveView.cmp_id != preActiveView.cmp_id) {
        return true;
      }
    }
    return false;
  }

  onRowTouchTap(id) {
    this.setState({ isShowChoose: true }, () => {
      const params = {
        id,
        viewName: this.props.cmp_data.viewName,
        metaObjName: this.props.queryUrl.metaObjName
      };
      this.props.actions.rowButtonListfn(params);
    });
  }

  getMetaFieldPath(field) {
    if (!this.IndexData || !this.IndexData.SearchForm || !this.IndexData.SearchForm.sub_cmps) {
      return null;
    }

    const fieldCmp = this.IndexData.SearchForm.sub_cmps.find(item => item.cmp_data && item.cmp_data.field_name === field);
    if (fieldCmp && fieldCmp.cmp_data && fieldCmp.cmp_data.hasOwnProperty('metaFieldRelationIDPath')) {
      return fieldCmp.cmp_data.metaFieldRelationIDPath;
    }

    return null;
  }

  getSearchCondition() {
    const { SearchForm } = this.IndexData;
    ;

    if (SearchForm) {
      let searchParams = {
        'metaObjName': SearchForm.cmp_data ? SearchForm.cmp_data.metaObjectName : '',
        'searchView': SearchForm.cmp_data ? SearchForm.cmp_data.viewName : '',
        'items': [],
        'searchFormFilterJson': SearchForm.cmp_data && SearchForm.cmp_data.filterJson || null
      };

      for (let key in SearchForm.biz_data) {
        const isInvalid = (!SearchForm.biz_data[key].text && SearchForm.biz_data[key].text !== 0) && (!SearchForm.biz_data[key].value && SearchForm.biz_data[key].value !== 0);

        // 移动端过滤掉部门多选的搜索字段
        const searchItem = SearchForm.sub_cmps && SearchForm.sub_cmps.find(item => item.cmp_data && item.cmp_data.biz_data_key === key);
        const isMultiDepartmentSearch = searchItem && searchItem.cmp_type === 'BC_MultiDepartmentSearch';

        if (!isInvalid && !isMultiDepartmentSearch) {
          let searchItem = {
            name: key,
            text: SearchForm.biz_data[key].text,
            value: SearchForm.biz_data[key].value,
            num: '',
            metaObjName: ''
          };

          if (SearchForm.biz_data[key].hasOwnProperty('num')) {
            searchItem.num = SearchForm.biz_data[key].num;
          }

          const metaFieldRelationIDPath = this.getMetaFieldPath(key);
          if (metaFieldRelationIDPath !== null) {
            searchItem.metaFieldRelationIDPath = metaFieldRelationIDPath;
          }

          searchParams.items.push(searchItem);
        }

      }
      if (SearchForm.customview_biz_data) {
        SearchForm.customview_biz_data.map(item => {
          searchParams.items.push(item);
        });
      }
      return searchParams;
    }
    return {};
  }
  /***滑动列表隐藏导航和toolsbar中间的元素,底部按钮 start */
  hideTopAndBottom() {
    if (!this.props.isIndexPop && !this.currentViewIsCustomComponent && !this.hideBar && (this.refs.indexWidget || existButton(this.IndexData))) {
      this.hideTopRaf = window.requestAnimationFrame(() => {
        this.hideBar = true;
        this.refs.indexWidget.changeStickyStyle({ position: 'absolute' });
        this.refs.indexFooter.changeFooterStyle({ zIndex: -1 });
        window.cancelAnimationFrame(this.hideTopRaf);
      });
    }
  }

  displayTopAndBottom() {
    if (!this.props.isIndexPop && this.hideBar && (this.refs.indexWidget || existButton(this.IndexData))) {
      this.showTopRaf = window.requestAnimationFrame(() => {
        this.hideBar = false;
        this.refs.indexWidget.changeStickyStyle({ position: 'relative', transform: 'translateY(0px)', holderHeight: '0px' });
        this.refs.indexFooter.changeFooterStyle({ transform: 'translateY(0px)', zIndex: 0 });
        window.cancelAnimationFrame(this.showTopRaf);
      });
    }
  }

  changeHolderHeight(height) {
    const indexContent = this.refs.indexContent;
    if (indexContent) {
      indexContent.changeHolderHeight && indexContent.changeHolderHeight(height);
    }
  }

  getDomHeight(dom) {
    return ReactDOM.findDOMNode(dom) && ReactDOM.findDOMNode(dom).offsetHeight || 0;
  }
  /***滑动列表隐藏导航和toolsbar中间的元素,底部按钮 end */

  getContentScrollTop() {
    return this.refs.indexContent && this.refs.indexContent.getContentScrollTop;
  }

  showFooter() {
    return existButton(this.IndexData) && !this.hideBar && !this.props.isIndexPop;
  }

  setSortData(data) {
    if (data.hasOwnProperty('sortData')) {
      this.sortData = data.sortData ? data.sortData.slice() : data.sortData;
    }
  }

  reloadTable(data, source) {
    const indexContent = this.refs.indexContent;
    if (indexContent) {
      indexContent.reload(data, source);
    }
  }

  switchViewShowChange() {
    this.refs.indexNav.componentDidUpdate();
  }

  closePop() {
    this.refs.indexWidget && this.refs.indexWidget.closePop(); //视图切换与toolsBar弹层互斥
  }

  getTip(tipInfo) {
    if (tipInfo && tipInfo.message != '') {
      return <Prompts { ...tipInfo } type={tipInfo.type || 'success'} show="true" />;
    }
    return null;
  }

  viewActived(view) {
    if (view.cmp_data && view.cmp_data.renderUseCustomComponent) {
      this.activeViewChanged = true;
      //处理视图是一个扩展视图，不是平台标准视图的逻辑
      //这种情况下，会直接将这个视图渲染到当前页面内
      //将IndexData中的NavView的currentViewName修改为扩展视图名称
      if (this.IndexData && this.IndexData.NavView && this.IndexData.NavView.cmp_data) {
        this.IndexData.NavView.cmp_data.currentViewName = view.name;
      }
      this.forceUpdate();
    } else {
      // 切换视图后 重置页面状态：页面滚动到顶部
      this.hideBar = true;
      this.handleToTop();
      this.activeViewChanged = false;
      this.currentViewIsCustomComponent = false;
      this.customComponent = null;
      const queryObj = helper.getQueryObject();
      let fetchParams = {
        metaObjName: view.metaObjName,
        isClick: true
      };
      fetchParams[queryObj.navViewName ? 'navViewName' : 'viewName'] = view.name;
      for (let key in queryObj) {
        if (key !== 'navViewName' && key !== 'viewName' && key !== 'metaObjName') {
          fetchParams[key] = queryObj[key];
        }
      }


      this.props.actions.fetchIndexPage(fetchParams);
    }
  }
  /***回到顶部start */
  handleToTop() {
    this.refs.indexContent.handleToTop();
  }

  displayToTop() {
    this.refs.toTop && (this.refs.toTop.style.display = 'block');
  }

  hideToTop() {
    this.refs.toTop && (this.refs.toTop.style.display = 'none');
  }
  /***回到顶部end */
  isTabView() {
    return this.navView && this.navView.cmp_data && this.navView.cmp_data.mode === 'Tab';
  }

  isCustomComponent() {
    if (hasNavViewData(this.IndexData)) {
      const currentViewName = this.IndexData.NavView.cmp_data.currentViewName;
      const currentView = this.IndexData.NavView.sub_cmps.find(item => item.cmp_data.name === currentViewName);
      if (currentView && currentView.cmp_data && currentView.cmp_data.renderUseCustomComponent) {
        this.customComponent = currentView.cmp_data.renderUseCustomComponent;
        return true;
      } {
        this.customComponent = null;
        return false;
      }
    }
  }

  currentDetailPageViewName() {
    return this.props.cmp_data.currentDetailPageViewName;
  }

  getFooterHeight() {
    return this.refs.indexFooter ? (this.refs.indexFooter.footerHeight || 0) : 0;
  }
  renderNav() {
    const { errors, isClick, queryUrl, actions, isIndexPop, popButtonData } = this.props;
    const navAttr = {
      errors,
      isClick,
      actions,
      isIndexPop,
      popButtonData,
      indexData: this.IndexData,
      queryUrl: queryUrl,
      closePop: this.closePop,
      showChange: this.switchViewShowChange,
      viewActived: this.viewActived,
      translation: this.translation
    };
    return <IndexNav ref='indexNav' { ...navAttr } />;
  }

  renderWidget() {
    const { actions, isIndexPop } = this.props;
    const widgetAttr = {
      actions, isIndexPop,
      isTabView: this.isTabView(),
      currentViewIsCustomComponent: this.currentViewIsCustomComponent,
      indexData: this.IndexData,
      reloadTable: this.reloadTable,
      getSearchCondition: this.getSearchCondition,
      viewActived: this.viewActived,
      changeHolderHeight: this.changeHolderHeight
    };

    return (<div style={{ position: 'relative', width: '100%', zIndex: '1', flexShrink: 0 }}>
      <IndexWidget ref="indexWidget" { ...widgetAttr } />
    </div>);
  }

  renderContent() {
    const { errors, queryUrl, actions, tableAjaxParam, isIndexPop, popParams, popButtonData } = this.props;
    const contentAttr = {
      tableAjaxParam,
      errors,
      queryUrl,
      actions,
      isIndexPop,
      popParams,
      popButtonData,
      translation: this.translation,
      indexPageProps: this.props,
      indexData: this.IndexData,
      currentViewIsCustomComponent: this.currentViewIsCustomComponent,
      customComponent: this.customComponent,
      onRowTouchTap: this.onRowTouchTap,
      hideTopAndBottom: this.hideTopAndBottom,
      displayTopAndBottom: this.displayTopAndBottom,
      displayToTop: this.displayToTop,
      hideToTop: this.hideToTop,
      hasSticky: this.refs.indexWidget,
      hasButton: this.showFooter,
      isFetching: this.props.isFetching || (this.IndexData.TableList && this.IndexData.TableList.isFetching),
      searchData: this.getSearchCondition(),
      indexContext: indexContext(this.IndexData),
      cmpContext: cmpContext(this.IndexData, queryUrl),
      setSortData: this.setSortData,
      getFooterHeight: this.getFooterHeight
    };
    return <IndexContent ref='indexContent' { ...contentAttr } />;
  }

  renderFooter() {
    const { errors, queryUrl, actions } = this.props;
    const footerAttr = {
      errors,
      actions,
      queryUrl,
      hideBar: this.hideBar,
      reloadTable: this.reloadTable,
      indexData: this.IndexData,
      getSearchCondition: this.getSearchCondition,
      currentDetailPageViewName: this.currentDetailPageViewName,
      getScrollTop: this.getContentScrollTop
    };
    return <IndexFooter ref="indexFooter" { ...footerAttr } />;
  }

  render() {
    // 无视图时
    let errorInfo = helper.getErrorInfo(this.props.errors);
    // 移动端不展示ocean视图(后端在删除ocean试图后,navView无数据的情况)
    if (!errorInfo && this.IndexData && this.IndexData.NavView && this.IndexData.NavView.sub_cmps && this.IndexData.NavView.sub_cmps.length == 0) {
      errorInfo = { errorType: 'inner_401' };// 内部401错误
    }
    const { isIndexPop } = this.props;
    if (errorInfo) {
      return (
        <Page>
          <IndexNav ref='indexNav' errors={this.props.errors} translation={this.translation} isIndexPop={this.props.isIndexPop} popButtonData={this.props.popButtonData} />
          <Content style={{ 'background': '#ffffff' }}>
            <ErrorPage { ...errorInfo } />
          </Content>
        </Page>
      );
    }

    this.currentViewIsCustomComponent = this.isCustomComponent();
    return (
      <Page cls='index-page' ref="page">
        {this.renderNav()}
        {this.renderWidget()}
        {this.renderContent()}
        {isIndexPop ? null : this.renderFooter()}
        <div className="toTop" ref="toTop" onTouchTap={this.handleToTop}><span>{this.translation.toTop}</span></div>
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Pages/IndexPage.js